import { IRedirectOptions } from '@/types/redirect';
import { Post, Put } from './helpers';
import { ThemeName } from '@/types/theme';
import getRequestBodyTheme from '@/themes/utils/get-request-body-theme';

export const ForgotPassword = async (
  email: string,
  hostname: string,
  redirectOptions?: IRedirectOptions,
  theme?: ThemeName
): Promise<boolean> => {
  return Post<boolean>({
    url: '/v3/admin/auth/forgot-password?app=login',
    body: { email, hostname, redirectOptions, theme: getRequestBodyTheme(theme) },
    ignoreResponse: true,
  });
};

export const UpdatePassword = async (password: string, code: string): Promise<{ email: string }> => {
  return Put<{ email: string }>({
    url: '/v3/admin/auth/forgot-password',
    body: { password, code },
    ignoreResponse: true,
  });
};
